var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRotateRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icRotateRight") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.10535348,3.03458876 L0.667270042,3.73266154 L2.50933977,7.58615157 L6.33520319,5.72857479 L5.64343788,4.28174522 L4.3689573,4.90037813 C5.38731252,3.32945486 7.13449313,2.35543477 9.05448394,2.35543477 C12.1411053,2.35543477 14.6533882,4.88735491 14.6533882,8 C14.6533882,11.112664 12.1410865,13.6446584 9.05448394,13.6446584 C7.23717158,13.6446584 5.52541344,12.7496091 4.47623788,11.2503223 L4.33184551,11.0439835 L3.02770993,11.9709379 L3.17006828,12.1742806 C4.51836719,14.1001713 6.71785277,15.25 9.05448394,15.25 C13.0226923,15.25 16.25,11.9974195 16.25,8 C16.25,4.00256998 13.0227127,0.75 9.05448394,0.75 C6.41951941,0.75 4.03683767,2.17894356 2.77875881,4.44374697 L2.10535348,3.03458876 Z",
    id: "icRotateRight",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(8.458635, 8.000000) scale(-1, 1) translate(-8.458635, -8.000000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRotateRight);
export default __webpack_public_path__ + "static/media/icRotateRight.010dd2dc7b9c161ecd5153415609a38c.svg";
export { ForwardRef as ReactComponent };